/** Canonical horizontal rail for workspace work-object pages. */
export const WORKSPACE_CONTENT_RAIL_CLASS = "mx-auto w-full max-w-7xl space-y-6 px-4 py-4 md:px-6";

/** Shared horizontal rail for the sibling Result and Traces views. */
export const RUN_VIEW_CONTAINER_CLASS = WORKSPACE_CONTENT_RAIL_CLASS;
